import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaTotalDevido = (): TabelaColuna => ({
  Chave: 'TotalDevido',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.moeda(linha.TotalDevido)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Total Devido</div>
})
